// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ZSJ2","approved":"Status_approved__2Mgyq","rejected":"Status_rejected__38jZI","expired":"Status_expired__dUctN","label":"Status_label__2mG00"};